<template>
  <v-container>
    <!-- Proveïdor -->
    <v-simple-table v-if="proveidor" class="mt-12">
      <thead>
        <h1>Vista detallada de proveïdor</h1>
      </thead>
      <tbody>
        <tr>
          <td>
            <b>Nom</b>
          </td>
          <td>{{ proveidor.nom }}</td>
        </tr>
        <tr>
          <td>
            <b>Població</b>
          </td>
          <td>{{ proveidor.poblacio }}</td>
        </tr>
        <tr v-if="proveidor.id_facturaplus">
          <td>
            <b>ID Facturaplus</b>
          </td>
          <td>{{ proveidor.id_facturaplus }}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <!-- Botons d'opcions -->
    <div id="botonera">
      <!-- Dialog/Modal per editar proveïdor -->
      <v-dialog v-model="dialogEditProveidor" persistent max-width="600">
        <template v-slot:activator="{ on }">
          <v-btn color="success" dark @click="btnDialogProveidor" v-on="on">Editar proveïdor</v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">Editar proveïdor</v-card-title>
          <v-container>
            <v-form id="formProveidor" ref="formProveidor" class="mt-12">
              <v-row>
                <v-col md="12">
                  <v-text-field v-model="proveidor_edit.nom" label="Nom" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12">
                  <v-text-field v-model="proveidor_edit.poblacio" label="Població" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12">
                  <v-text-field v-model="proveidor_edit.id_facturaplus" label="ID Facturaplus"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="dialogEditProveidor = false">Cancel·lar</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="btnEditProveidor"
              :disabled="!proveidor_edit.nom || !proveidor_edit.poblacio"
            >Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ./Dialog/Modal per editar proveïdor -->
      <!-- Dialog/Modal per eliminar bala -->
      <v-dialog v-model="dialogEliminarProveidor" persistent max-width="600">
        <template v-slot:activator="{ on }">
          <v-btn color="error" dark v-on="on">Eliminar proveïdor</v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">Confirmar eliminar proveïdor</v-card-title>
          <v-card-text>Està segur que vol eliminar este proveïdor?</v-card-text>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="dialogEliminarProveidor = false">Cancel·lar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="btnEliminarProveidor">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ./Dialog/Modal per eliminar bala -->
    </div>
    <!-- Botons d'opcions -->
    <!-- ./Proveïdor -->
    <!-- Footer -->
    <v-footer class="font-weight-medium" height="38%">
      <v-col class="text-center" cols="12" @click="redireccio('ProveidorList')" style="padding:0px">
        <span>Gestió Integral Borreres, {{ new Date().getFullYear() }}</span>
      </v-col>
    </v-footer>
    <!-- ./Footer -->
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

import { EventBus } from "@/event-bus.js";

export default {
  name: "proveidor-detail",
  data: () => ({
    proveidor: {
      nom: "",
      poblacio: "",
      id_facturaplus: ""
    },
    proveidor_edit: {
      nom: "",
      poblacio: "",
      id_facturaplus: ""
    },
    dialogEditProveidor: false,
    dialogEliminarProveidor: false
  }),
  methods: {
    ...mapActions(["editProveidor", "eliminarProveidor", "getProveidor"]),

    // Botonera
    btnDialogProveidor() {
      this.proveidor_edit = JSON.parse(JSON.stringify(this.proveidor));
    },
    btnEditProveidor() {
      this.editProveidor(this.proveidor_edit).then(response => {
        if (response === 200) {
          EventBus.$emit("Proveidor.Notificacio", {
            text: "Proveidor editat correctament",
            color: "success"
          });
          this.dialogEditProveidor = false;
          this.getProveidor(this.proveidor.id).then(
            proveidor => (this.proveidor = proveidor)
          );
        } else
          EventBus.$emit("Proveidor.Notificacio", {
            text: "Error editant el proveïdor",
            color: "error"
          });
      });
    },
    btnEliminarProveidor() {
      this.eliminarProveidor(this.proveidor.id).then(response => {
        if (response === 204) {
          EventBus.$emit("Proveidor.Notificacio", {
            text: "Proveidor eliminat correctament",
            color: "success"
          });
          this.$router.push({ name: "ProveidorList" });
        } else
          EventBus.$emit("Proveidor.Notificacio", {
            text: response.message,
            color: "error"
          });
      });
    },

    // Auxiliars
    redireccio(component) {
      this.$router.push({ name: component });
    }
  },
  created() {
    this.getProveidor(this.$route.params.id).then(
      proveidor => (this.proveidor = proveidor)
    );
  }
};
</script>

<style lang="scss" scoped>
// Taules
table {
  thead {
    h1 {
      text-align: center;
      padding-bottom: 1em;
    }
  }
  tbody {
    tr {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      td {
        width: 40%;
      }
    }
  }
}
#botonera {
  padding-bottom: 50px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  button {
    width: 45%;
  }
}
</style>